export default __webpack_public_path__ + "static/SellciusNetwork_logo-fd8be17cf6421f2683f6a0d03932486f.png";